import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMemberAuth } from '../hooks/useMemberAuth';
import Loading from '../components/common/Loading';

const COMPLETE_PHOTO_PATH = '/associado/completar-cadastro';

const MemberPrivateRoute = ({ children }) => {
  const { member, isAuthenticated, loading } = useMemberAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loading text="Verificando autenticação..." />
      </div>
    );
  }

  if (!isAuthenticated()) {
    return <Navigate to="/associado/login" replace />;
  }

  // Bloqueia acesso enquanto o associado não tiver foto cadastrada
  if (member && !member.photo_url && location.pathname !== COMPLETE_PHOTO_PATH) {
    return <Navigate to={COMPLETE_PHOTO_PATH} replace />;
  }

  return children;
};

export default MemberPrivateRoute;
